import React from 'react';
import styles from './ContentCinema.module.css';
import global from '../../styles/global.module.css';

import cinepolis  from '../../assets/images/cinepolis-c.png';
import kinoplex   from '../../assets/images/kinoplex-c.png';
import cinesystem from '../../assets/images/cinesystem-c.png';
import cinearaujo from '../../assets/images/cine-araujo.png';
import group29    from '../../assets/images/Group 29.png';
import group32    from '../../assets/images/Group 32.png';
import group33    from '../../assets/images/Group 33.png';
import group34    from '../../assets/images/Group 34.png';
import group555   from '../../assets/images/Group 555.png';
import vector     from '../../assets/images/Vector.png';

const logos = [
  cinepolis,
  group555,
  kinoplex,
  cinesystem,
  group32,
  group29,
  vector,
  group34,
  cinearaujo,
  group33,
];

const ContentCinema = () => {
  return (
    <section className={global.section} id="conteudos">
      <div className={global.sectionHeader}>
        <h2>Conteúdos</h2>
        <p>
          Nossa seleção de conteúdos foi pensada para oferecer recompensas com alto impacto emocional e adesão.
        </p>
      </div>

      <div className={styles.ticket}>
        <div className={styles.strokeOverlay}></div>

        <h3 className={styles.title}>Cinema</h3>
        <strong className={styles.subtitle}>A magia da telona em todo o Brasil.</strong>
        <p className={styles.description}>
          Vouchers resgatáveis nas principais redes de cinema do país — uma experiência memorável com alto valor percebido.
        </p>

        <div className={styles.divider}></div>

        <p className={styles.partners}>
          Parcerias com as principais redes do Brasil para proporcionar experiências cinematográficas em todo o país.
        </p>

        <div className={styles.logoGrid}>
          {logos.map((logo, index) => (
            <img key={index} src={logo} alt={`Logo ${index}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContentCinema;
